<div>
  <span> &copy; {{todaysDate | date:'y'}} Information Services Group. All Rights Reserved. </span>
</div>
